import React, { Component } from 'react';
import { Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import Breadcrumbs, { textResolver } from 'react-router-breadcrumbs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Footer, Navigation, TopHeader, Logout } from '../common';
import { layoutHelper } from '../layouts';
import { titleize } from '../../utils/helpers/text_formatters';

class Admin extends Component {
  componentDidMount() {
    layoutHelper();
  }

  activeRoute(routeName, level = 2) {
    const {
      location: { pathname },
    } = this.props;
    const checker = level === 2 ? pathname === routeName : pathname.includes(routeName);
    return checker ? 'active' : null;
  }

  render() {
    const {
      user: { name },
      dispatch,
      routes,
      routeParams,
    } = this.props;

    const CustomLink = (link, key, text, index, routers) => {
      const isLastElement = index === routers.length - 1;
      const cls = isLastElement ? '' : 'active';
      return (
        <li key={key}>
          <Link to={link} className={cls}>
            {titleize(text)}
          </Link>
        </li>
      );
    };

    return (
      <div id="wrapper">
        <Navigation>
          <li className={this.activeRoute('/admin') || this.activeRoute('/admin/publisher')}>
            <Link to="/admin/publisher">
              <FontAwesomeIcon icon="user-cog" /> Publishers
            </Link>
          </li>
          <li className={this.activeRoute('/admin/advertiser')}>
            <Link to="/admin/advertiser">
              <FontAwesomeIcon icon="user-edit" /> Advertisers
            </Link>
          </li>
          <li className={this.activeRoute('/admin/websites')}>
            <Link to="/admin/websites">
              <FontAwesomeIcon icon="globe-americas" /> Websites
            </Link>
          </li>
          <li className={this.activeRoute('/admin/statement')}>
            <Link to="/admin/statement">
              <FontAwesomeIcon icon="university" /> Statements
            </Link>
          </li>
          <li className={this.activeRoute('/admin/campaign')}>
            <Link to="/admin/campaign">
              <FontAwesomeIcon icon="calendar-alt" /> Campaigns
            </Link>
          </li>
          <li className={this.activeRoute('/admin/feed_logs')}>
            <Link to="/admin/feed_logs">
              <FontAwesomeIcon icon="rss-square" /> Feed Logs
            </Link>
          </li>
          <li className={this.activeRoute('/admin/account')}>
            <Link to="/admin/account">
              <FontAwesomeIcon icon="user-plus" /> Accounts
            </Link>
          </li>
          <li className={this.activeRoute('/admin/sales_rep')}>
            <Link to="/admin/sales_rep">
              <FontAwesomeIcon icon="dollar-sign" /> Sales Reps
            </Link>
          </li>
          {/* <li className={this.activeRoute('/admin/ad')}>
            <Link to="/admin/ad">
              <FontAwesomeIcon icon="bullhorn" /> Ads
            </Link>
          </li> */}
          {/* <li className={this.activeRoute('/admin/email_alert', 1)}>
            <a href="javascript:void(0);">
              <FontAwesomeIcon icon="envelope" /> Email Alerts
              <span className="fa arrow" />
            </a>
            <ul className="nav nav-second-level collapse">
              <li className={this.activeRoute('/admin/email_alerts/campaign')}>
                <Link to="/admin/email_alerts/campaign">
                  <span className="nav-label">Campaigns</span>
                </Link>
              </li>
            </ul>
          </li> */}
          <li className={this.activeRoute('/admin/reports/publisher')}>
            <Link to="/admin/reports/publisher">
              <FontAwesomeIcon icon="book" /> Reports (Pub)
            </Link>
          </li>
          <li className={this.activeRoute('/admin/reports/advertiser')}>
            <Link to="/admin/reports/advertiser">
              <FontAwesomeIcon icon="book" /> Reports (Adv)
            </Link>
          </li>
          <li className={this.activeRoute('/admin/connection_reports')}>
            <Link to="/admin/connection_reports">
              <FontAwesomeIcon icon="book" /> Connection Reports
            </Link>
          </li>
        </Navigation>

        <div id="page-wrapper" className="gray-bg">
          <TopHeader sideBtn>
            <Nav pullRight className="navbar-top-links">
              <NavDropdown eventKey={1} title={name} id="basic-nav-dropdown" href="javascript:void(0);">
                <MenuItem href="javascript:void(0);" onClick={() => dispatch(push('/'))}>
                  Home
                </MenuItem>
                <Logout />
              </NavDropdown>
            </Nav>
          </TopHeader>
          <div className="wrapper wrapper-content">
            <div className="m-b-md">
              <Breadcrumbs
                resolver={textResolver}
                routes={routes}
                wrappingComponent={'ol'}
                className={'breadcrumb'}
                createLink={CustomLink}
                params={routeParams}
                createSeparator=""
              />
            </div>
            {this.props.children}
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    auth: {
      data: { payload },
    },
    routing: { locationBeforeTransitions },
  } = state;
  return {
    user: payload,
    location: locationBeforeTransitions,
  };
};

export default connect(mapStateToProps)(Admin);
